import keyMirror from 'fbjs/lib/keyMirror';

// Using module.exports so that `import { KEY_NAME } from './constants/actionTypes'` works
module.exports = keyMirror({
    OPENED_IMAGE_CROPPER: null,
    CLOSED_IMAGE_CROPPER: null,
    IMAGE_CROPPER_CONFIG_CHANGED: null,
});
